<template>
  <div id="data-list-list-view" class="data-list-container">
    <vs-table ref="table" responsive pagination :max-items="itemsPerPage" search :data="originList">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
            <div
              class="
                p-4
                border border-solid
                d-theme-border-grey-light
                rounded-full
                d-theme-dark-bg
                cursor-pointer
                flex
                items-center
                justify-between
                font-medium
              "
            >
              <span class="mr-2">{{ minItemsPerPage }} - {{ currentItemsPerPage }} of {{ queriedItems }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage = 4">
                <span>4</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 20">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 50">
                <span>50</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </div>

      <template slot="thead">
        <vs-th sort-key="uploadID">{{$t(`DATASOURCEVIEW.origin`)}}</vs-th>
        <vs-th sort-key="description">{{$t(`DATASOURCEVIEW.description`)}}</vs-th>
        <vs-th sort-key="companyName">{{$t(`DATASOURCEVIEW.company`)}}</vs-th>
        <vs-th sort-key="processStatus">{{$t(`DATASOURCEVIEW.process`)}}</vs-th>
        <vs-th sort-key="totalRecords">{{$t(`DATASOURCEVIEW.numberRecords`)}}</vs-th>
        <vs-th sort-key="status">{{$t(`DATASOURCEVIEW.state`)}}</vs-th>
        <vs-th>{{$t(`DATASOURCEVIEW.actions`)}}</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name font-medium">
                {{ tr.uploadID | OriginDataSource }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-category">{{ tr.description }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.companyName }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.processStatus }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.totalRecords }}</p>
            </vs-td>

            <vs-td>
              <vs-progress :percent="100" :color="tr.status | getPopularityColor" class="shadow-md" />
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                class="ml-2"
                icon="InfoIcon"
                svgClasses="w-5 h-5 hover:text-success stroke-current"
                @click.stop="infoData(tr)"
              />

              <feather-icon
                class="ml-2"
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                @click.stop="deleteData(tr)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import * as Origins from "./Origin";
import { notify } from "@/helpers/$vs.js";

export default {
  data() {
    return {
      activeForm: {},
      activePrompt: false,
      selectedFormVersion: 1,

      activePopup: false,
      listGroups: [],

      recordId: null,
      originList: [],
      itemsPerPage: 7,
      isMounted: false
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        // return this.$refs.table.currentx;
        return true;
      }
      return 0;
    },
    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.originList.length;
    },
    minItemsPerPage() {
      return this.currentPage * this.itemsPerPage - (this.itemsPerPage - 1);
    },
    currentItemsPerPage() {
      return this.originList.length - this.currentPage * this.itemsPerPage > 0
        ? this.currentPage * this.itemsPerPage
        : this.originList.length;
    }
  },
  filters: {
    OriginDataSource(uploadID) {
      return uploadID === "external" ? "Externo" : "Interno";
    },
    getPopularityColor(status) {
      switch (status) {
        case "Active":
          return "primary";
          break;
        case "Inactive":
          return "warning";
          break;
        case "Blocked":
          return "danger";
          break;
        case "Banned":
          return "danger";
          break;
        case "Deleted":
          return "danger";
          break;
        default:
          return "warning";
          break;
      }
    }
  },
  methods: {
    async getAllOrigins() {
      this.$vs.loading({ type: "sound" });

      try {
        const result = await Origins.getAllOrigins();
        this.originList = result;
      } catch (error) {
        const message = error.data.reason ? error.data.reason : `(${error.message})`;
        let text = "";
        if (message === "Origins list are empty") text = this.$t(`DATASOURCEVIEW.emptyOrigins`);
        notify(this.$t(`DATASOURCEVIEW.listForms`), text, "warning");
      } finally {
        this.$vs.loading.close();
      }
    },

    deleteData(data) {
      this.recordId = data.key;

      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t(`DATASOURCEVIEW.deleteOrigin`, {description: data.description}),
        text: this.$t(`DATASOURCEVIEW.messagge1`),
        acceptText: this.$t(`DATASOURCEVIEW.accept`),
        cancelText: this.$t(`DATASOURCEVIEW.cancel`),
        accept: this.deleteOriginItem
      });
    },

    async deleteOriginItem() {
      this.$vs.loading({ type: "sound" });

      try {
        await Origins.deleteOrigin(this.recordId);
        await this.getAllOrigins();
      } catch (error) {
        console.log("deleteOriginItem Error:", error);

        this.$vs.notify({
          title: this.$t(`DATASOURCEVIEW.titleDeleteOrigen`),
          text: this.$t(`DATASOURCEVIEW.errorToDeleteOrigen`),
          color: "warning",
          icon: "error",
          time: 6000
        });
      } finally {
        this.recordId = null;
        this.$vs.loading.close();
      }
    },

    infoData(data) {
      this.$vs.notify({
        title: this.$t(`DATASOURCEVIEW.originData`),
        text:  this.$t(`DATASOURCEVIEW.actionNotAvailable`),
        color: "warning",
        icon: "error",
        time: 4500
      });
    }
  },
  mounted() {
    this.isMounted = true;
    this.getAllOrigins();
  }
};
</script>

<style lang="scss">
#data-list-list-view {
  @import "@/assets/css/_themeTable.scss";
}
</style>
